var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 85,
    viewBox: "0 0 79 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9505 84.2145C16.1342 84.2145 0 68.1001 0 48.264C0 28.4476 16.1342 12.3333 35.9505 12.3333C55.7668 12.3333 71.901 28.4674 71.901 48.2838C71.8812 68.1001 55.7668 84.2145 35.9505 84.2145ZM35.9505 16.2926C18.3118 16.2926 3.95931 30.645 3.95931 48.264C3.95931 65.8829 18.3118 80.2552 35.9505 80.2552C53.5892 80.2552 67.9417 65.9027 67.9417 48.264C67.9417 30.6252 53.5892 16.2926 35.9505 16.2926Z",
    fill: "#20B46D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.753 66.833C35.7332 66.833 35.7332 66.833 35.753 66.833C33.7733 66.833 31.9125 65.8431 30.8237 64.2L17.2432 43.9284C15.422 41.1965 16.1544 37.5143 18.8666 35.693C21.5985 33.8717 25.2806 34.6042 27.1019 37.3163L35.753 50.2435L67.9422 2.61302C69.7832 -0.0991052 73.4654 -0.831577 76.1775 1.0095C78.8896 2.85058 79.6023 6.53273 77.781 9.26465L40.6625 64.2198C39.5539 65.8431 37.7129 66.833 35.753 66.833Z",
    fill: "#20B46D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.81,
    height: 84.2145,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.e9ea29fdede5cae0c98598f1a5c60f5c.svg";
export { ForwardRef as ReactComponent };